import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    allProjects: string;
    ariaLabelProjects: string;
    ariaLabelLoading: string;
    showProjectMenu: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for All Projects section in the Project Switcher */
            allProjects: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherProjectList.allProjects?c=1s4rel3o4dxvr", defaultMessage: "All Projects" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the projects list in the Project Switcher */
            ariaLabelProjects: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherProjectList.ariaLabelProjects?c=2u813xmjxcsfx", defaultMessage: "Projects" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the projects loading state in the Project Switcher */
            ariaLabelLoading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherProjectList.ariaLabelLoading?c=57512ik3sq66", defaultMessage: "Loading" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for the project menu toggle in the Project Switcher */
            showProjectMenu: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectSwitcherProjectList.showProjectMenu?c=3t35ku1t1m4z3", defaultMessage: "Show project menu" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
